<template>
  <router-link v-slot="{ isActive, isExactActive }" :to="to" custom>
    <slot :href="href" :is-active="isActive" :is-exact-active="isExactActive" :on-click="onClick" />
  </router-link>
</template>

<script>
import { defineComponent } from 'vue'

import { replaceForgeLocationHash } from '@/utils/external-link-helper'
import { forgeView } from '@/utils/forge-helpers/general'
import { isCrossPlatformAppInjectionKey, isWebAppInjectionKey } from '@/utils/injection-keys'

export default defineComponent({
  name: 'AppLink',

  inject: {
    isWebApp: {
      from: isWebAppInjectionKey
    },

    isCrossPlatformApp: {
      from: isCrossPlatformAppInjectionKey
    }
  },

  inheritAttrs: false,

  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },

  emits: { click: null },

  data() {
    return {
      href: ''
    }
  },

  computed: {
    resolvedTo() {
      return this.$router.resolve(this.to)
    }
  },

  watch: {
    resolvedTo: {
      async handler(resolvedTo) {
        if (forgeView) {
          const result = await replaceForgeLocationHash({ hash: resolvedTo.fullPath, fresh: false })

          if (!result) return

          this.href = result
        } else if (this.isWebApp) {
          this.href = resolvedTo.href
        } else if (this.isCrossPlatformApp) {
          this.href = resolvedTo.href
        } else {
          this.href = resolvedTo.fullPath
        }
      },

      immediate: true
    }
  },

  methods: {
    onClick() {
      const resolvedTo = this.$router.resolve(this.to)
      if (this.$route.fullPath === resolvedTo.fullPath) {
        return
      }
      this.$emit('click')
      this.$router.push(this.to)
    }
  }
})
</script>

<style></style>
